import SVGProps from 'src/components/icons/config/svg-props' //
// Auto-generated file created by svgr-cli source svg-template.cjs
// Run npm run generate-icons to update
// Do not edit
const SvgChevronUpIcon = (props: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    fill="none"
    viewBox="0 0 64 64"
    role="img"
    className="icon"
    {...props}
  >
    <path
      fill="currentColor"
      d="M27.07 23.601a3.2 3.2 0 0 1 2.498-1.201h4.862a3.2 3.2 0 0 1 2.5 1.201l12.319 15.4-2.499 1.998L34.43 25.6h-4.862L17.248 41l-2.498-2z"
    />
  </svg>
)
export default SvgChevronUpIcon
